import React, { FC, useState } from 'react';
import { Dialog } from 'primereact/dialog';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye } from '@fortawesome/free-solid-svg-icons';
import { KeyValuePairs } from '@/components';
import styles from './DocumentDetail.module.scss';
import { DocumentsHistoryListInfo } from '../../types';

type ModalDetailsProps = {
  rowData: DocumentsHistoryListInfo;
};

export const parseProformaDetails = (apiResponse: string | undefined) => {
  let details;
  let total;
  const removeFirstUS = (input: string): string => {
    return input.replace(/U\$S/, '').trim();
  };

  if (!apiResponse) {
    return { details: [], total: 0 };
  }
  if (apiResponse) {
    const lines = apiResponse
      .split('\r\n')
      .filter((line) => line.trim() !== '' && !line.trim().startsWith('TOTAL'));

    const groupedLines: string[] = [];
    lines.forEach((line, index) => {
      if (
        (line.startsWith('Almacenaje') ||
          line.startsWith('Segregación') ||
          line.startsWith('Suministro')) &&
        lines[index + 1]
      ) {
        groupedLines.push(
          `${line} <br /> <span class=${styles.fontWeightLight}>${removeFirstUS(lines[index + 1])}</span>`
        );
      } else if (
        !lines[index - 1] ||
        (!lines[index - 1].startsWith('Almacenaje') &&
          !lines[index - 1].startsWith('Segregación') &&
          !lines[index - 1].startsWith('Suministro'))
      ) {
        groupedLines.push(line);
      }
    });

    details = groupedLines
      .filter((line) => !line.startsWith('CONTENEDOR'))
      .map((groupedLine: string) => {
        const [description, amountPart] = groupedLine
          .split('U$S')
          .map((part) => part.trim());
        const amountString = amountPart
          ? amountPart.split(' ')[0].replace(',', '.')
          : '0';
        const amount = parseFloat(amountString);

        return {
          key: description.replace('días a', 'días a U$S'),
          amount: Number.isNaN(amount) ? 0 : amount,
        };
      });

    const totalLinesS = apiResponse
      .split('\r\n')
      .filter((line: string) => line.trim() !== '');

    const totalLine = totalLinesS[lines.length - 1];

    const totalLines = totalLinesS.find((line: string) =>
      line.includes('TOTAL')
    );
    total = 0;
    if (totalLine) {
      const totalParts = totalLines?.split('TOTAL');
      const totalString =
        totalParts && totalParts.length > 1 ? totalParts[1].trim() : '0';
      total = totalString;
    }
  }
  return { details, total };
};
//   if (!data) return null;
//   const { lineas } = data.factura || {};

//   if (!lineas) return parseDetailText(data?.detalle, 'Almacenaje Import');

//   const items = (lineas || [])
//     .map((linea) => {
//       const subitems = linea.detalle.map(({ tarifaValor, importe, texto }) => {
//         const valor = parseAmount(tarifaValor);

//         const breakLineAtEnd = texto.endsWith('\r\n');
//         const cleanedText = breakLineAtEnd ? texto.slice(0, -2) : texto;
//         const textParts = cleanedText.split('\r\n');
//         const currentLabel = textParts[textParts.length - 1]?.trim() || '';
//         const textWithoutValue = currentLabel.split('U$S')[0]?.trim() || '';

//         const label = `${textWithoutValue}  ${tarifaValor ? `U$S ${valor}` : ''}`;

//         return {
//           label,
//           value: importe,
//           items: [],
//         };
//       });

//       return {
//         label: (linea?.textoImpresion || '')
//           .split('\r\n')[0]
//           ?.split('U$S')[0]
//           ?.trim(),
//         value: linea?.importe || 0,
//         items: subitems?.length > 1 ? subitems : [],
//       };
//     })
//     .filter((item) => item.label && item.value);

//   return { items, total: data?.total || 0 };
// };

const ModalDetailDocumentsHistory: FC<ModalDetailsProps> = ({ rowData }) => {
  const [isDialogShown, setIsDialogShown] = useState(false);
  const { t } = useTranslation('documentsHistory');

  const toggleDialog = () => {
    setIsDialogShown(!isDialogShown);
  };

  const dialogHeader = (
    <div className="text-blue-800">
      <FontAwesomeIcon icon={faEye} style={{ marginRight: '0.5rem' }} />
      {t('modalTitle')}
    </div>
  );

  const keyValuePairs = [
    { key: 'Tipo', value: rowData.feTipoCFETexto },
    { key: 'Serie', value: rowData.feSerieCFE },
    { key: 'Nro', value: rowData.feNroCFE },
    { key: 'Contenedor', value: rowData.contenedor },
  ];
  const { details, total } = parseProformaDetails(rowData.descripcionFactura);

  return (
    <>
      <FontAwesomeIcon
        icon={faEye}
        onClick={toggleDialog}
        style={{ cursor: 'pointer' }}
      />

      <Dialog
        header={dialogHeader}
        visible={isDialogShown}
        style={{
          maxWidth: window.innerWidth <= 1200 ? '95vw' : '1200px',
          minWidth: window.innerWidth <= 1200 ? '95vw' : '1200px',
        }}
        onHide={toggleDialog}
        modal
        breakpoints={{ '1200px': '95vw' }}
      >
        <div className="pb-4 px-4">
          <KeyValuePairs pairs={keyValuePairs} boldValues />

          <ul
            className={`${styles.list} ${styles.listAddProforma} ${styles.detailProforma}`}
          >
            {details?.map(
              (result) =>
                result && (
                  <React.Fragment key={`${result?.key}`}>
                    <li>
                      <span
                        /* eslint-disable-next-line react/no-danger */
                        dangerouslySetInnerHTML={{ __html: result?.key }}
                      />
                      <div className={styles.amount}>
                        {result?.amount?.toFixed(2)}
                      </div>
                    </li>
                    <hr />
                  </React.Fragment>
                )
            )}
          </ul>
          {total && (
            <div className={styles.divTotalContainer}>
              <strong>{t('totalLabel')}</strong>
              <div className={styles.totalAmount}>
                <strong>{total}</strong>
              </div>
            </div>
          )}
        </div>
      </Dialog>
    </>
  );
};

export default ModalDetailDocumentsHistory;
